import type { UserInfo } from "@shared/models";
import { create } from "zustand";

export interface Conversation {
  conversationid: number;
}

export interface AppState {
  hasOrg: boolean;
  userInfo?: UserInfo;
  filter: string;
  allConversations: Conversation[];
  filteredConversations: Conversation[];
  setHasOrg: (hasOrg: boolean) => void;
  setUserInfo: (userInfo: UserInfo | undefined) => void;
  setFilter: (filter: string) => void;
  setAllConversations: (all: Conversation[]) => void;
  setFilteredConversations: (filtered: Conversation[]) => void;
}

export const useAppStore = create<AppState>()((set) => ({
  hasOrg: false,
  userInfo: undefined,
  filter: "",
  allConversations: [],
  filteredConversations: [],
  setHasOrg: (hasOrg) => set(() => ({ hasOrg })),
  setUserInfo: (userInfo) => set(() => ({ userInfo })),
  setAllConversations: (all) => set(() => ({ allConversations: all })),
  setFilteredConversations: (filtered) => set(() => ({ filteredConversations: filtered })),
  setFilter: (filter) => set(() => ({ filter }))
}));
